import type {QueryParams} from '@jetbrains/teamcity-ui/dist/utils'

export const searchParamsToObject = (params: URLSearchParams): QueryParams =>
  [...params.entries()].reduce((acc, [key, value]) => ({...acc, [key]: value}), {})
export const queryToObject = (query?: string): QueryParams =>
  searchParamsToObject(new URLSearchParams(query))

export const parseCommaSeparated = (value: string | null | undefined): string[] => {
  if (!value || value === 'all') {
    return []
  }
  return value.split(',').filter(Boolean)
}

export const toCommaSeparated = (values: ReadonlyArray<string>): string | null =>
  values.length > 0 ? values.join(',') : null

export const serializeTags = (tags: ReadonlyArray<string>): string | null =>
  tags.length > 0 ? JSON.stringify(tags).slice(1, -1) : null

export const parseTags = (
  tagsParam: string | null | undefined,
  tagParam?: string | null | undefined,
): string[] => {
  if (tagsParam) {
    try {
      return (JSON.parse(`[${tagsParam}]`) as unknown[]).map(String)
    } catch {
      return [tagsParam]
    }
  }
  if (tagParam) {
    return [tagParam]
  }
  return []
}

/**
 * Merge `updates` into `currentSearch` using URLSearchParams,
 * so that entries for keys NOT mentioned in `updates` are preserved.
 */
export const mergeSearchParams = (
  currentSearch: string | undefined,
  updates: QueryParams | null | undefined,
): string => {
  const params = new URLSearchParams(currentSearch ?? '')
  if (updates != null) {
    for (const key of Object.keys(updates)) {
      const value = updates[key]
      params.delete(key)
      if (value != null) {
        params.set(key, value)
      }
    }
  }
  return params.toString()
}

export const parseBuildFilters = (
  stateParam: string | null | undefined,
  pinnedParam: boolean | string | null | undefined,
  starredParam: boolean | string | null | undefined,
): {buildState: string[]; pinned: boolean; starred: boolean} => {
  const raw = parseCommaSeparated(stateParam)
  return {
    buildState: raw.filter(s => s !== 'pinned' && s !== 'starred'),
    pinned: pinnedParam === true || pinnedParam === 'true' || raw.includes('pinned'),
    starred: starredParam === true || starredParam === 'true' || raw.includes('starred'),
  }
}
